"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Players_module_css_1 = __importDefault(require("../Players/Players.module.css"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var material_1 = require("@mui/material");
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var editorOrigin = process.env.QPLAY_EDITOR_HOST ? process.env.QPLAY_EDITOR_HOST : "";
var Accordion = (0, material_1.styled)(function (props) { return (react_1.default.createElement(Accordion_1.default, __assign({ disableGutters: true, elevation: 0 }, props))); })(function () { return ({
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&::before": {
        display: "none",
    },
}); });
var AccordionSummary = (0, material_1.styled)(function (props) { return (react_1.default.createElement(AccordionSummary_1.default, __assign({ expandIcon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faAngleRight }) }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
        },
        "& .MuiAccordionSummary-content": {
            marginLeft: theme.spacing(1),
        },
        "& .MuiTypography-root": {
            fontFamily: "Geomanist-bold",
            color: "var(--info-color)",
        }
    });
});
var AccordionDetails = (0, material_1.styled)(AccordionDetails_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
    });
});
var defaultSavingState = { saving: false, saved: false, text: "" };
var EditorMetadataModal = function (_a) {
    var editorIframeRef = _a.editorIframeRef;
    var _b = (0, q_play_components_1.useModal)(), isShown = _b.isShown, toggle = _b.toggle;
    var _c = (0, react_1.useState)({}), preselectedKeys = _c[0], setPreselectedKeys = _c[1];
    var _d = (0, react_1.useState)({}), selectedKeys = _d[0], setSelectedKeys = _d[1];
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _e = (0, react_1.useState)(defaultSavingState), savingState = _e[0], setSavingState = _e[1];
    var _f = (0, react_1.useState)([]), metadata = _f[0], setMetadata = _f[1];
    var logger = q_play_core_1.logManager.getLogger();
    var _g = (0, react_1.useState)([]), expandedPanels = _g[0], setExpandedPanels = _g[1];
    var sendMetadataMessageToEditor = function (metadataArray) {
        var formattedMetadataArray = metadataArray.map(function (metadata) {
            var metadataIdKey = metadata.metadata_id.toString();
            var selectedMetadataKeys = selectedKeys[metadataIdKey] || {};
            return {
                id: metadata.metadata_id,
                meta_key: metadata.meta_key,
                description: metadata.description,
                keys: JSON.stringify(selectedMetadataKeys),
            };
        });
        var data = {
            state: { open: isShown },
            type: "metadata",
            metadata: formattedMetadataArray,
        };
        if (editorIframeRef.current && formattedMetadataArray.length > 0) {
            editorIframeRef.current.contentWindow.postMessage(data, editorOrigin);
            toggle();
        }
    };
    var confirmSelectedMetadata = function () {
        var selectedMetadataArray = Object.entries(selectedKeys).map(function (_a) {
            var idKey = _a[0], keyValuePairs = _a[1];
            var metadataId = parseInt(idKey, 10);
            var metadataItem = metadata.find(function (meta) { return meta.id === metadataId; });
            if (!metadataItem) {
                return null;
            }
            var selectedPairs = keyValuePairs || {};
            return __assign(__assign({}, metadataItem), { metadata: selectedPairs, metadata_id: metadataId });
        }).filter(Boolean);
        sendMetadataMessageToEditor(selectedMetadataArray);
    };
    (0, react_1.useEffect)(function () {
        var handleMessage = function (event) {
            if (event.origin !== editorOrigin || event.data.type !== "metadata") {
                return;
            }
            if (event.data.command === "toggle") {
                toggle();
            }
            if (event.data.preselectedKeys) {
                setPreselectedKeys(event.data.preselectedKeys);
            }
        };
        window.addEventListener("message", handleMessage);
        return function () {
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        var parsedPreselectedKeys = Object.keys(preselectedKeys).reduce(function (acc, key) {
            try {
                acc[key] = JSON.parse(preselectedKeys[key]);
            }
            catch (e) {
                logger.error("Error parsing preselected key:", e);
                acc[key] = [];
            }
            return acc;
        }, {});
        if (JSON.stringify(parsedPreselectedKeys) !== JSON.stringify(selectedKeys)) {
            setSelectedKeys(parsedPreselectedKeys);
        }
    }, [preselectedKeys]);
    (0, react_1.useEffect)(function () {
        if (isShown) {
            getMetadata();
        }
        else {
            setSelectedKeys({});
            setSavingState(defaultSavingState);
        }
    }, [isShown]);
    var getMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, formattedMetadata, metaKeys, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.getMetadata()];
                case 1:
                    response = _a.sent();
                    formattedMetadata = response.map(function (item) {
                        var parsedMeta = {};
                        try {
                            parsedMeta = typeof item.key_value_pairs === "string" ? JSON.parse(item.key_value_pairs) : item.key_value_pairs;
                        }
                        catch (e) {
                            logger.error("Error parsing metadata:", e);
                        }
                        return __assign(__assign({}, item), { key_value_pairs: parsedMeta });
                    });
                    setMetadata(formattedMetadata);
                    metaKeys = formattedMetadata.map(function (metadataItem) { return metadataItem.meta_key; });
                    setExpandedPanels(metaKeys);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error fetching metadata:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleKeySelection = function (idKey, key) {
        setSelectedKeys(function (prevSelectedKeys) {
            var updatedSelectedKeys = __assign({}, prevSelectedKeys);
            if (!updatedSelectedKeys[idKey]) {
                updatedSelectedKeys[idKey] = [];
            }
            if (updatedSelectedKeys[idKey].includes(key)) {
                var index = updatedSelectedKeys[idKey].indexOf(key);
                if (index > -1) {
                    updatedSelectedKeys[idKey].splice(index, 1);
                }
                if (updatedSelectedKeys[idKey].length === 0) {
                    delete updatedSelectedKeys[idKey];
                }
            }
            else {
                updatedSelectedKeys[idKey].push(key);
            }
            return updatedSelectedKeys;
        });
    };
    var renderKeys = function (idKey, keyValuePairs) {
        if (!keyValuePairs) {
            return null;
        }
        var displayObject;
        if (Array.isArray(keyValuePairs)) {
            displayObject = keyValuePairs.reduce(function (acc, item) {
                acc[item] = item;
                return acc;
            }, {});
        }
        else {
            displayObject = keyValuePairs;
        }
        return (react_1.default.createElement("div", { className: Players_module_css_1.default.accordion_body_container, style: { padding: "unset", marginBottom: "0.65em" } },
            react_1.default.createElement("div", { className: Players_module_css_1.default["available-metadata"] }, Object.entries(displayObject).map(function (_a, index) {
                var _b;
                var key = _a[0];
                var isSelected = (_b = selectedKeys[idKey]) === null || _b === void 0 ? void 0 : _b.includes(key);
                return (react_1.default.createElement(react_1.default.Fragment, { key: "".concat(idKey, "-").concat(key) },
                    react_1.default.createElement("div", { onClick: function () { return handleKeySelection(idKey, key); }, "data-cy": "metadataKeyValuePair", style: {
                            cursor: "pointer",
                            borderRadius: "3px",
                            backgroundColor: isSelected
                                ? "var(--secondary-color-tinted)"
                                : "transparent",
                            outline: isSelected
                                ? "2px var(--primary-color) solid"
                                : "none",
                            padding: "6px",
                            color: "var(--info-color)",
                            fontSize: "1.3rem",
                        } }, key),
                    index < Object.keys(displayObject).length - 1 && (react_1.default.createElement("span", { className: Players_module_css_1.default.separator }))));
            }))));
    };
    var handlePanelToggle = function (panel) {
        if (expandedPanels.includes(panel)) {
            setExpandedPanels(expandedPanels.filter(function (expandedPanel) { return expandedPanel !== panel; }));
        }
        else {
            setExpandedPanels(__spreadArray(__spreadArray([], expandedPanels, true), [panel], false));
        }
    };
    var dialogStyles = {
        "& .MuiDialog-paper": {
            overflow: "visible",
            borderRadius: "14px",
            maxWidth: "1100px",
            width: "100%",
        }
    };
    return (react_1.default.createElement(material_1.Dialog, { open: isShown, onClose: toggle, maxWidth: "lg", sx: dialogStyles, style: { zIndex: 1000 }, "data-cy": "metadata-popup" },
        react_1.default.createElement(material_1.IconButton, { "aria-label": "close", onClick: toggle, sx: {
                background: "var(--close-btn-color)",
                borderRadius: "50%",
                width: "42px",
                height: "42px",
                fontSize: "24px",
                cursor: "pointer",
                position: "absolute",
                right: -21,
                top: -21,
                "&:hover": {
                    background: "var(--close-btn-color)",
                },
            } },
            react_1.default.createElement("div", { "data-cy": "modalCloseBtn" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faXmark, style: { color: "var(--info-color)" } }))),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement("span", { style: { fontFamily: "Geomanist-bold", color: "var(--info-color)" } }, t("Edit metadata")),
            react_1.default.createElement("div", { className: Players_module_css_1.default.group_name_container }, metadata.map(function (metadataItem) {
                var idKey = metadataItem.id.toString();
                return (react_1.default.createElement(Accordion, { key: idKey, expanded: expandedPanels.includes(metadataItem.meta_key), onChange: function () { return handlePanelToggle(metadataItem.meta_key); } },
                    react_1.default.createElement(AccordionSummary, null,
                        react_1.default.createElement(material_1.Typography, null, metadataItem.meta_key)),
                    react_1.default.createElement(AccordionDetails, null, renderKeys(idKey, metadataItem.key_value_pairs))));
            })),
            react_1.default.createElement("div", { className: "d-flex justify-content-end mt-4" },
                savingState.saved &&
                    react_1.default.createElement("span", { style: { fontFamily: "Geomanist", margin: "auto 1rem" } }, t(savingState.text)),
                react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), size: "small", dataCy: "attachMetadataButton", onClick: confirmSelectedMetadata, isDisabled: savingState.saving || Object.keys(selectedKeys).length === 0 })))));
};
exports.default = EditorMetadataModal;
